// extracted by mini-css-extract-plugin
export default {"pc-dialog-title":"styles_pc-dialog-title__MO6W9"};